import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import Logo from "../components/layout/Logo";
import { Field, darkInputCls } from "../components/forms/Fields";
import { useAuth } from "../context/AuthContext";
import { api, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user?.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.role !== "admin") {
        await api.post("/auth/logout");
        setUser(false);
        setError("This account does not have admin access.");
        return;
      }
      setUser(data);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain relative flex min-h-screen items-center justify-center bg-navy px-5">
      <div className="grid-lines absolute inset-0" />
      <form onSubmit={submit} data-testid="admin-login-form" className="glass-dark relative w-full max-w-md space-y-5 rounded-[2rem] p-10">
        <Logo />
        <div className="flex items-center gap-2 pt-4 text-sm font-semibold uppercase tracking-[0.2em] text-gold"><Lock size={14} /> Admin Console</div>
        <Field dark label="Admin email" id="a-email"><input id="a-email" type="email" required className={darkInputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" /></Field>
        <Field dark label="Password" id="a-pass"><input id="a-pass" type="password" required className={darkInputCls} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" /></Field>
        {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit-btn" className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-gold text-sm font-semibold text-navy hover:bg-[#e2c27f] disabled:opacity-60">
          {loading && <Loader2 size={16} className="animate-spin" />} Sign in to admin
        </button>
      </form>
    </div>
  );
}
